import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';
import { CoachmarkTrigger } from 'dibs-elements/exports/CoachmarkTrigger';
import { Tooltip } from 'dibs-elements/exports/Tooltip';
import scrollIntoView from 'scroll-into-view';

import styles from './TradeOnboardingCoachmark.scss';

export class TradeOnboardingCoachmark extends React.Component {
    constructor(props) {
        super(props);
        this.conditionallyUpdateState = this.conditionallyUpdateState.bind(this);
        this.handleTooltipDismissal = this.handleTooltipDismissal.bind(this);
        this.scrollToTooltip = this.scrollToTooltip.bind(this);
        this.tooltipRef = React.createRef();

        this.state = {
            coachmarkViewRecorded: false,
            dismissed: false,
            showTooltip: false,
            tooltipViewRecorded: false,
        };
    }

    componentDidMount() {
        this.conditionallyUpdateState();
    }

    componentDidUpdate() {
        this.conditionallyUpdateState();
    }

    conditionallyUpdateState() {
        const { logCoachmarkView, showCoachmark, showModal, trackTooltipView } = this.props;
        const { coachmarkViewRecorded, dismissed, showTooltip, tooltipViewRecorded } = this.state;

        if (showCoachmark && !coachmarkViewRecorded) {
            this.setState({ coachmarkViewRecorded: true }, () => {
                logCoachmarkView();
            });
        }

        if (trackTooltipView && showTooltip && !tooltipViewRecorded) {
            this.setState({ tooltipViewRecorded: true }, () => {
                trackTooltipView();
            });
        }
    }

    handleTooltipDismissal() {
        this.setState({ dismissed: true }, this.props.logTooltipDismissal);
    }

    openTooltip = () => {
        this.setState({ showTooltip: true });
    };

    scrollToTooltip() {
        this.setState({ showTooltip: true }, () => {
            const tooltipDomElement = this.tooltipRef.current;
            const align = { top: 0.25 };
            scrollIntoView(tooltipDomElement, { time: 500, align });
        });
    }

    render() {
        const {
            ModalComponent,
            showCoachmark,
            showModal,
            tooltipBodyMessage,
            tooltipDirection,
            tooltipAlign,
            tooltipType,
            tooltipHeaderMessage,
            wrapperClass,
        } = this.props;
        const { dismissed, showTooltip } = this.state;

        if (!showCoachmark || dismissed) {
            return null;
        }

        return (
            <div className={wrapperClass}>
                <CoachmarkTrigger
                    dataTn="trade-onboarding-coachmark"
                    onMouseEnter={this.openTooltip}
                    type="trade"
                >
                    <Tooltip
                        type={tooltipType}
                        align={tooltipAlign}
                        isVisible={showTooltip}
                        direction={tooltipDirection}
                        dataTn="trade-onboarding-tooltip"
                    >
                        <div className={styles.tooltipHeader} ref={this.tooltipRef}>
                            {tooltipHeaderMessage}
                        </div>
                        <div className={styles.tooltipBody}>{tooltipBodyMessage}</div>
                        <div className={styles.tooltipButtonWrapper}>
                            <Button
                                dataTn="close-trade-onboarding-tooltip-button"
                                onClick={this.handleTooltipDismissal}
                                size="small"
                                type="secondary"
                            >
                                <FormattedMessage
                                    id="TradeOnboardingCoachmark.close"
                                    defaultMessage="Close"
                                />
                            </Button>
                        </div>
                    </Tooltip>
                </CoachmarkTrigger>
                {showModal && <ModalComponent onPrimaryCtaClick={this.scrollToTooltip} />}
            </div>
        );
    }
}

TradeOnboardingCoachmark.defalutProps = {
    showTooltipOnInitialRender: false,
    tooltipType: 'coachmark',
};

TradeOnboardingCoachmark.propTypes = {
    logCoachmarkView: PropTypes.func.isRequired,
    logTooltipDismissal: PropTypes.func.isRequired,
    ModalComponent: PropTypes.func,
    showCoachmark: PropTypes.bool,
    showModal: PropTypes.bool,
    tooltipBodyMessage: PropTypes.object.isRequired,
    tooltipDirection: PropTypes.string.isRequired,
    tooltipHeaderMessage: PropTypes.object.isRequired,
    trackTooltipView: PropTypes.func,
    wrapperClass: PropTypes.string.isRequired,
    tooltipAlign: PropTypes.string,
    tooltipType: PropTypes.string,
};
